"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingPeriodSummary = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const diem_1 = __importDefault(require("@travelnest/diem"));
const Button_1 = require("../button/Button");
const theme_1 = __importDefault(require("../styles/theme"));
const helpers_1 = require("../../../entities/pricing/helpers");
const InlineMessage_1 = require("../inline-message/InlineMessage");
const Spacer_1 = require("../spacer/Spacer");
const helpers_2 = require("../../pages/tasks/pricing/helpers");
const Wrapper = styled_1.default.div `
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
const IconTextWrapper = styled_1.default.div `
	display: flex;
	align-items: center;
`;
const Period = styled_1.default.div `
	${theme_1.default.typography.c1};
`;
const PeriodSubText = styled_1.default.div `
	${theme_1.default.typography.c2};
`;
const PeriodGeneratedText = styled_1.default.div `
	background-color: ${theme_1.default.colours.primary.misc};
	border-radius: 25px;
	color: ${theme_1.default.colours.neutral.white};
	margin-top: ${theme_1.default.layout.spacing.small};
	padding-left: 10px;
	margin-right: 50px;
	font-size: ${theme_1.default.typography.c3.fontSize};
`;
const Icon = styled_1.default.div `
	color: ${theme_1.default.colours.neutral.white};
	background-color: ${theme_1.default.colours.primary.misc};
	width: 40px;
	height: 40px;
	text-align: center;
	line-height: 40px;
	font-weight: 500;
	border-radius: 50%;
	margin-right: ${theme_1.default.layout.spacing.small};
`;
const ButtonWrapper = styled_1.default.div `
	border-left: 1px solid ${theme_1.default.colours.neutral.light};
	padding-left: ${theme_1.default.layout.spacing.small};
`;
const PricingPeriodSummary = ({ period, onEditClicked, hasError, }) => {
    const { min, max } = (0, helpers_2.periodMinMaxPrices)(period);
    return react_1.default.createElement(Wrapper, { "data-testId": `pricing-period-summary-${period.start_date}` },
        react_1.default.createElement(IconTextWrapper, null,
            react_1.default.createElement(Icon, null, (0, helpers_1.getCurrencySymbol)(period.currency)),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Period, null, period.name),
                react_1.default.createElement(PeriodSubText, null, `Starts on ${(0, helpers_2.humanizeDateFormat)(new diem_1.default(period.start_date))}`),
                react_1.default.createElement(PeriodSubText, null, (0, helpers_1.pricesHighLowFormatted)(min, max, period.currency)),
                ((0, helpers_2.isDefaultFilled)(period)) ? react_1.default.createElement(PeriodGeneratedText, null, "Default period") : null,
                hasError && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Spacer_1.Spacer, { spacing: "smaller" }),
                    react_1.default.createElement(InlineMessage_1.InlineError, { text: "This period is incomplete." }))))),
        react_1.default.createElement(ButtonWrapper, null,
            react_1.default.createElement(Button_1.Button, { onClick: () => onEditClicked(period), buttonType: Button_1.PresetThemes.Neutral }, "Edit")));
};
exports.PricingPeriodSummary = PricingPeriodSummary;
//# sourceMappingURL=PricingPeriodSummary.js.map